import CustomPanel from 'components/controls/CustomPanel';
import React from 'react';
import FlexibleFieldView, { EScopeType } from '../FlexibleFieldView';
import FeesGrid from '../FeesGrid';
import { IVisibilityScope } from 'global/Visibility/IVisibilityScope.type';
import MonthlyRecurringFees from '../MonthlyRecurringFees';
import { IFeesAndPremiums } from 'model/FlexibleAttributeModel';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import { BuildVisibilityScope } from 'global/Visibility/GlobalVisibility';

interface IProps {
    disabled?: boolean;
    feesAndPremium: IFeesAndPremiums; // Replace with the actual type
    visibility?: IVisibilityScope; // Replace with the actual type
}

const FeesAndPremiumView: React.FC<IProps> = (props) => {
    const state = useSelector((state: RootState) => state); // Replace with the actual state type 

    const categoryFeesPremiums = state.data?.config?.cache?.map_bcbs_config_category_named["Fees and Premiums"];

    const disabled = props.disabled; // props.state.status.viewType !== EViewType.Modify;

    const feesAndPremium = props.feesAndPremium;

    const controlVisibility = props.visibility ?? BuildVisibilityScope(
        null,
        state.data.json,
        null,
        null
    );

    return (
        <>

            <CustomPanel title={"Attributes"} canCollapse={true} defaultCollapsed={false} >
                <FlexibleFieldView
                    disabled={disabled}
                    fields={feesAndPremium.fields}
                    category={categoryFeesPremiums}
                    tiers={[]}
                    scope={feesAndPremium}
                    visibility={controlVisibility}
                    scopeType={EScopeType.feesAndPremium}
                />
            </CustomPanel>

            <FeesGrid
                disabled={disabled}
                feesAndPremium={feesAndPremium}
                creditHidden={true}
                visibility={controlVisibility}
            />

            <MonthlyRecurringFees
                feesAndPremium={feesAndPremium}
            />
        </>
    );
};

export default FeesAndPremiumView;